import { SxProps, ToggleButton } from '@mui/material';
import { FC } from 'react';

interface Props {
  className?: string;
  value: NonNullable<unknown>;
  selected?: boolean;
  onChange?: (event: React.MouseEvent<HTMLElement>, value: any) => void;
  children: React.ReactNode;
  sx?: SxProps;
}

export const QcsToggleButton: FC<Props> = ({
  className,
  value,
  selected,
  onChange,
  children,
  sx,
}) => {
  return (
    <ToggleButton
      className={className}
      sx={sx}
      value={value}
      selected={selected}
      onChange={onChange}
    >
      {children}
    </ToggleButton>
  );
};
